export const formatMoney = (val) => {
    let num = parseFloat(val);

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        num = 0.0;
    }

    if (num < 0) {
        const negativeNum = Math.abs(num).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        return `(${negativeNum})`;
    }

    return num.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}